import { render, staticRenderFns } from "./SelectStudents.vue?vue&type=template&id=3a7779b5&scoped=true"
import script from "./SelectStudents.vue?vue&type=script&lang=ts"
export * from "./SelectStudents.vue?vue&type=script&lang=ts"
import style0 from "./SelectStudents.vue?vue&type=style&index=0&id=3a7779b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7779b5",
  null
  
)

export default component.exports